var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndiaFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3285_3558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99916 0.499512C4.82747 0.499512 2.08697 2.34529 0.792969 5.02126H15.2053C13.9113 2.34529 11.1708 0.499512 7.99916 0.499512Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99916 16.4998C11.1708 16.4998 13.9113 14.654 15.2053 11.978H0.792969C2.08697 14.654 4.82747 16.4998 7.99916 16.4998Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99939 11.282C9.53618 11.282 10.782 10.0362 10.782 8.49939C10.782 6.96261 9.53618 5.7168 7.99939 5.7168C6.46261 5.7168 5.2168 6.96261 5.2168 8.49939C5.2168 10.0362 6.46261 11.282 7.99939 11.282Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00084 10.2385C8.96133 10.2385 9.73996 9.45987 9.73996 8.49938C9.73996 7.53889 8.96133 6.76025 8.00084 6.76025C7.04035 6.76025 6.26172 7.53889 6.26172 8.49938C6.26172 9.45987 7.04035 10.2385 8.00084 10.2385Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00111 6.354L8.53764 7.57082L9.85965 7.42703L9.07414 8.50007L9.85965 9.5731L8.53764 9.42932L8.00111 10.6461L7.46458 9.42932L6.14258 9.57307L6.92808 8.50007L6.14258 7.42703L7.46458 7.57082L8.00111 6.354Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3285_3558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaFlag);
export default __webpack_public_path__ + "static/media/IndiaFlag.5f2b0ebc611eb16e84d5bd7e892a004c.svg";
export { ForwardRef as ReactComponent };